export default __webpack_public_path__ + "static/media/manasis-refram-logo.7ddf2180.png";